module.exports = __webpack_public_path__ + "static/media/rated.12e9a5af.svg";